import AIPromptVersionHistoryPage from './pages/ai_prompts/version_history';
import AIPromptRequestPage from './pages/test_prep/ai/prompt_requests/show';

const routes = [
  {
    exact: true,
    path: '/admin/ai_prompts/:id/versions',
    component: AIPromptVersionHistoryPage
  },
  {
    exact: true,
    path: '/admin/ai_prompts/:id/versions/:versionId',
    component: AIPromptVersionHistoryPage
  },
  {
    exact: true,
    path: '/admin/test_prep/ai/prompt_requests/:id',
    component: AIPromptRequestPage
  }
];

export default routes;
